<div
  fxFlex="100"
  class="custom-hub-grid">

  <div
    fxLayout="row wrap"
    fxLayoutGap="32px grid"
    fxLayoutGap.mm-mobile="20px grid"
    class="custom-hub-grid__container">

    <div
      class="custom-hub-grid__card-container"
      *ngFor="let category of categories; let i = index">

      <app-custom-hub-card
        [category]="category">
      </app-custom-hub-card>

    </div>
  </div>
</div>
